import { Container } from 'inversify'
import * as Mappers from '@rw1/mappers'

const container = new Container({ autoBindInjectable: true })

container.bind<Mappers.ICompanyDataMapper>(Mappers.MapperTypes.ICompanyDataMapper).to(Mappers.CompanyDataMapper).inTransientScope()
container.bind<Mappers.ISessionManagementMapper>(Mappers.MapperTypes.ISessionManagementMapper).to(Mappers.SessionManagementMapper).inTransientScope()
container.bind<Mappers.IUserGeneratedContentMapper>(Mappers.MapperTypes.IUserGeneratedContentMapper).to(Mappers.UserGeneratedContentMapper).inTransientScope()
container.bind<Mappers.IUserManagementMapper>(Mappers.MapperTypes.IUserManagementMapper).to(Mappers.UserManagementMapper).inTransientScope()
container.bind<Mappers.IContentDeliveryMapper>(Mappers.MapperTypes.IContentDeliveryMapper).to(Mappers.ContentDeliveryMapper).inTransientScope()

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const bindDependencies = <T extends (...args: any[]) => any>(func: T, dependencies: symbol[]): (...args: Parameters<T>) => ReturnType<T> => {
    // eslint-disable-next-line prefer-const
    let injections = dependencies.map((dependency) => {
        return container.get(dependency);
    });

    return func.bind(func, ...injections);
}

export { bindDependencies, container };